import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Button } from "components/common/Button";
import type { GridSelectionChipProps } from "./types";

export const GridSelectionChip = ({
  selectedCount,
  isBusy,
  onClearSelection,
}: GridSelectionChipProps) => {
  const { t } = useTranslation();

  const hasSelection = selectedCount > 0;

  return (
    <div
      className={clsx(
        "flex items-center gap-2 rounded-full py-1 text-sm transition-colors",
        hasSelection
          ? "bg-blue-50 pl-3 pr-1 text-blue-700"
          : "bg-gray-100 px-3 text-gray-500",
      )}
    >
      <span>
        {t("smartSurveyor.gridReview.selectedCount", {
          count: selectedCount,
        })}
      </span>
      {hasSelection && (
        <>
          <span className="h-4 w-px bg-blue-200" />
          <Button
            variant="inverted"
            size="sm"
            onClick={onClearSelection}
            disabled={isBusy}
            className="!rounded-full !py-0.5 hover:!bg-indigo-100"
          >
            {t("smartSurveyor.gridReview.clearSelection")}
          </Button>
        </>
      )}
    </div>
  );
};
